import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { restRequest } from '../../../Helpers/RequestHelper';

import NotFound from '../../../Components/NotFound/NotFound';
import Loader from '../../../Components/Loader/Loader';
import CurrencyFormEnhanced from './CurrencyFormEnhancer';

import './CurrencyForm.css';
import { checkError } from '../../../Helpers/AuthHelper';
import { t } from 'i18next';

class CurrencyForm extends Component {
  type = this.props.type || 'add';
  id = this.props.id || this.props.match.params.id || null;

  state = {
    currency: {
      name: '',
      currencyCode: '',
      symbol: '',
      exchangeRate: 1,
    },
    currencyId: null,
    currencyListFromDB: [],
    global_currencies: [],
    selectedCurrency: null,
    loading: true,
    notFound: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    switch (this.type) {
      case 'edit':
        await this.fetchCurrencyEditData();
        break;
      case 'add':
      default:
        await this.fetchCurrencyList();
    }

    this.setState({
      loading: false,
    });
  }

  fetchCurrencyList() {
    return restRequest('get', 'currencies/create')
      .then((response) => {
        this.setState({
          currencyListFromDB: response,
          global_currencies: response.global_currencies || [],
        });
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        this.setState({ loading: false });
      });
  }

  fetchCurrencyEditData() {
    return restRequest('get', `currencies/${this.id}/edit`)
      .then((response) => {
        const { currency, global_currencies } = response;
        let data = response.global_currencies.find(
          (element) => element.name === response.currency.name
        );
        this.setState({
          currency: {
            ...this.state.currency,
            name: currency.name,
            currencyCode: currency.currency_code,
            symbol: currency.symbol,
            exchangeRate: currency.exchange_rate,
            currencyId: currency.currency_code || currency.id,
            global_currency_id: data.id,
          },
          currencyId: currency.currency_code,
          selectedCurrency: currency,
          global_currencies: global_currencies || [],
        });
      })
      .catch((error) => {
        if (checkError(error) === 404) {
          this.setState({ notFound: true });
        }
      });
  }

  submitRequestType() {
    switch (this.type) {
      case 'edit':
        return 'PUT';
      case 'add':
      default:
        return 'post';
    }
  }

  submitRequestUrl() {
    switch (this.type) {
      case 'edit':
        return `currencies/${this.id}`;
      case 'add':
      default:
        return 'currencies';
    }
  }

  successMessage = () => {
    if (this.type === 'add') {
      this.props.handleToast(
        t('common.currency_created_successfully'),
        'success'
      );
      this.props.closeEditmodal();
      this.props.fetchDataWithQueryString();
    } else {
      this.props.handleToast(
        t('common.currency_created_successfully'),
        'success'
      );
      // console.log(this.props.closeEditmodal(), "closeEditmodal()")
      this.props.closeEditmodal();
      this.props.fetchDataWithQueryString();
    }
  };

  render() {
    if (this.state.loading) return <Loader />;
    if (this.state.notFound) return <NotFound />;
    return (
      <CurrencyFormEnhanced
        type={this.type}
        currency={this.state.selectedCurrency}
        currencyListFromDB={this.state.currencyListFromDB}
        global_currencies={this.state.global_currencies}
        handleToast={this.props.handleToast}
        history={this.props.history}
        initialValues={this.state.currency}
        requestType={this.submitRequestType()}
        requestUrl={this.submitRequestUrl()}
        successMessage={this.successMessage}
        closeEditmodal={this.props.closeEditmodal}
        onSubmit={this.props.onSubmit}
        fromInvoice={this.props.fromInvoice}
      />
    );
  }
}

export default withRouter(CurrencyForm);
